type CreateConfigRes = {
  loginEndpoint: string
  rollbarToken: string
  rollbarEnv: string
  intercomAppId: string
}

function createConfig(env: { [propName: string]: string | undefined }): CreateConfigRes {
  return {
    loginEndpoint: env.REACT_APP_LOGIN || `https://app${env.SUBDOMAIN_SUFFIX}.predictivehire.com/`,
    rollbarToken: env.REACT_APP_ROLLBAR_TOKEN,
    rollbarEnv: env.REACT_APP_ENVIRONMENT,
    intercomAppId: env.REACT_APP_INTERCOM_APP_ID
  }
}

const config = createConfig({
  REACT_APP_LOGIN: process.env.REACT_APP_LOGIN,
  REACT_APP_ROLLBAR_TOKEN: process.env.REACT_APP_ROLLBAR_TOKEN,
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_INTERCOM_APP_ID: process.env.REACT_APP_INTERCOM_APP_ID
})

export { config, createConfig }
